module.exports = __webpack_public_path__ + "static/media/share.0da43363.svg";